/**
 * @class FilterDetailHeader
 *
 * Header for a single filter's detail view: the filter title above the link back to the
 * filter list, with an optional action (e.g. Clear) rendered opposite the back link.
 */
import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbsBack from '../lookups/breadcrumbsBack';
const FilterDetailHeader = ({
  title,
  onBack,
  action: _action = null
}) => {
  const back = /*#__PURE__*/React.createElement(BreadcrumbsBack, {
    onBack: onBack,
    onSelect: onBack,
    backLabel: "Filters"
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, title), _action ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-start"
  }, back, _action) : back);
};
FilterDetailHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  action: PropTypes.node
};
export default FilterDetailHeader;